var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"ytvideo"}},[_c('div',{staticClass:"video-container"},[_c('div',{attrs:{"id":_vm.videoContainerId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }